import React from 'react';
import { Navbar } from './Navbar';
import { Hero } from './Hero';
import { Summary } from './Summary';
import { Experience } from './Experience';
import { Skills } from './Skills';
import { Education } from './Education';
import { Contact } from './Contact';
export function Resume() {
  return <div className="min-h-screen bg-background selection:bg-accent/20 selection:text-primary" data-id="element-85">
      <Navbar data-id="element-86" />
      <main data-id="element-87">
        <Hero data-id="element-88" />
        <Summary data-id="element-89" />
        <Experience data-id="element-90" />
        <Skills data-id="element-91" />
        <Education data-id="element-92" />
        <Contact data-id="element-93" />
      </main>
    </div>;
}